import script from "./ReportPageLetter.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPageLetter.vue?vue&type=script&setup=true&lang=js"

import "./ReportPageLetter.vue?vue&type=style&index=0&id=2ea5a4a0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea5a4a0"]])

export default __exports__